import { bindActionCreators } from 'redux';
import { Map, List } from 'immutable';
import { connect } from '../../../../common/react-redux';
import { closeModal, withConfirm } from '../../../../common/actions/modal';
import { set } from '../../../../common/actions/ui';
import { removeStimulusQuizEntry } from '../../../api/quizEntries';
import { DeleteStimulusModal as DeleteStimulusModalPresenter } from './presenter';
import { DELETE_STIMULUS_MODAL, DELETE_STIMULUS_DATA, DELETE_STIMULUS_MODAL_SELECTED_CHILDREN, DELETE_STIMULUS_MODAL_DELETION_MODE } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var _state$getIn$toObject = state.getIn(['ui', DELETE_STIMULUS_DATA], Map()).toObject(),
    stimulusEntry = _state$getIn$toObject.stimulusEntry,
    childEntries = _state$getIn$toObject.childEntries,
    quizId = _state$getIn$toObject.quizId;
  var selectedChildren = state.getIn(['ui', DELETE_STIMULUS_MODAL_SELECTED_CHILDREN]);
  var deletionMode = state.getIn(['ui', DELETE_STIMULUS_MODAL_DELETION_MODE]);
  return {
    modalOpen: state.getIn(['modal', 'isOpen']) === DELETE_STIMULUS_MODAL,
    stimulusEntry: stimulusEntry,
    selectedChildren: selectedChildren,
    deletionMode: deletionMode,
    quizId: quizId,
    childEntries: childEntries || List()
  };
}
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: bindActionCreators(closeModal, dispatch),
    removeStimulus: bindActionCreators(removeStimulusQuizEntry, dispatch),
    setUi: bindActionCreators(set, dispatch),
    withConfirm: bindActionCreators(withConfirm, dispatch)
  };
};
export var DeleteStimulusModal = connect(mapStateToProps, mapDispatchToProps)(DeleteStimulusModalPresenter);
export default DeleteStimulusModal;